import CasteIcon from "../assests/images/caste-icon.png";
import LangIcon from "../assests/images/lang-icon.png";
import FromLocationIcon from "../assests/images/from-location.png";
import ResidesIcon from "../assests/images/resides-icon.png";
import LivingIcon from "../assests/images/living-icon.png";
import MarryIcon from "../assests/images/marry-icon.png";
import DownloadIcon from "../assests/images/download-icon.png";
import likeIcon from "../assests/images/like_icon.png";
import dislikeIcon from "../assests/images//dislike_icon.png";
import copyIcon from "../assests/images/copy_icon.png";
import shareIcon from "../assests/images/share_icon.png";
import MatchIcon from "../assests/images/matches-icon.png";
import ApprovedIcon from "../assests/images/approved-profiles-icon.png";
import NetworkIcon from "../assests/images/client-network-icon.png";
import ClientPrepIcon from "../assests/images/clinet-preferance-icon.png";
import { useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "../Styles/ProfileDisplayForClient.css";
import FamilyDetails from "./FamilyDetails";
import EducationAndCareer from "./EducationAndCareer";
import IntroductionVideo from "./IntroductionVideo";
import MenuBar from "./MenuBar";
import SidebarMatches from "./SidebarMatches";
import { calculateAge } from "../utils/commonFunctions";

import {
  check_access_request,
  get_access_request,
  get_agent,
  get_caste_name,
  get_castes,
  get_communities,
  get_district_cities,
  get_habits,
  get_hobbies,
  get_language,
  get_level1_caste,
  get_marital_status,
  get_matches_for_client,
  get_notifications,
  get_physical_build,
  get_profile_byid,
  get_qualification,
  get_relations,
  get_religios,
  get_skin_tone,
  send_access_request,
  get_notifications_for_profiles,
} from "../api/serverWrapper";
import ClientPreferences from "./ClientPreferences";
import ApprovedProfiles from "./ApprovedProfiles";
import { clearAllData, getData } from "../utils/store-data";
import { AGENT_LOGIN } from "../utils/store-data-constants";
import MenuBarforClient from "./MenuBarforClient";
import SidebarMatchesForClient from "./SidebarMatchesForClient";
import { useNavigate } from "react-router-dom";
import ApprovedProfilesForClient from "./ApprovedProfilesForClient";
import { useMasterData } from "../context/MasterDataContext";
import MyAgent from "../components/MyAgent";
import WedlukVisibility from "../components/WedlukVisibility";
import DashboardProfileView from "./DashboardProfileView";

const allIcons = {
  like_icon: likeIcon,
  dislike_icon: dislikeIcon,
  copy_icon: copyIcon,
  share_icon: shareIcon,
};

const ProfileDisplayForClient = () => {
  const {
    religionMasterData,
    countryMasterData,
    allCasteMasterData,
    maritalStatusMasterData,
    skinToneMasterData,
    buildMasterData,
    habitsMasterData,
    hobbiesMasterData,
    qualificationMasterData,
    communityMasterData,
    languageMasterData,
    relationsMasterData,
    clientRelationsMasterData,
    communityDocsMasterData,
    allCountyMasterData,
  } = useMasterData();
  const navigate = useNavigate();
  const location = useLocation();
  const client = location.state?.client;

  const [displayActiveTab, setDisplayActiveTabs] = useState("Profile");
  const [displayAprrovedProfile, setDisplayAprrovedProfile] = useState(false);

  const [loadingNotifications, setLoadingNotifications] = useState(true);
  const [eventUpdates, setEventUpdates] = useState([]);
  const navigationTabs = ["Matches", "Approved Matches", "Profile"];

  console.log("client", client);

  const tabs = [
    { id: "network", label: "My Network", icon: NetworkIcon },
    { id: "preferences", label: "Client preferences", icon: ClientPrepIcon },
  ];

  const [activeTab, setActiveTab] = useState("matches");

  let [UserData, setUserData] = useState(null);
  const [religion, setReligion] = useState(religionMasterData);
  const [languages, setLanguage] = useState(languageMasterData);
  const [caste, setCaste] = useState([]);
  const [communityList, setCommunity] = useState([]);
  const [Loading, setLoading] = useState(false);
  let [data, setData] = useState([]);
  let [agentData, setAgentData] = useState([]);
  const [maritalStatus, setMaritalStatus] = useState(maritalStatusMasterData);
  const [skinToneList, setSkinToneList] = useState(skinToneMasterData);
  const [physicalbuildList, setPhysicalBuildList] = useState(buildMasterData);
  const [habitList, setHabitList] = useState(habitsMasterData);
  const [hobbiesList, setHobbiesList] = useState(hobbiesMasterData);
  const [qualifications, setQualifications] = useState(qualificationMasterData);
  const [relationList, setRelatonList] = useState(relationsMasterData);
  const [selectedQualification, setSelectedQualification] = useState(
    UserData?.QualificationId,
  );
  const [cityList, setCityList] = useState([]);
  const [isAgentLogin, setIsAgentLogin] = useState(true);
  const [selectedProfile, setSelectedProfile] = useState(null);

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setLoading(true);

      let data = await getData(AGENT_LOGIN);
      setIsAgentLogin(data);

      await getProfileByID(client?.ProfileId);
      await loadMathesData(client?.ProfileId);

      await getEvents(client?.ProfileId, client?.BusinessDetails?.UserId);

      if (
        UserData?.User?.Address?.StateId &&
        UserData?.User?.Address?.DistrictId
      ) {
        getCitys(
          UserData?.User?.Address?.StateId,
          UserData?.User?.Address?.DistrictId,
        );
      }
      setSelectedQualification(UserData?.QualificationId);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  async function getEvents(ProfileId, BusinessId) {
    try {
      setLoadingNotifications(true);
      let res = await get_notifications_for_profiles(ProfileId);
      console.log("Notifications ", res);
      if (res.success) {
        const notifications = res.data.map((item) => {
          const sender = item.Profile?.User;
          const receiver = item.ToProfile?.User;
          return {
            id: item.RequestId,
            fromProfileId: item.ToProfileId,
            toProfileId: item.ProfileId,
            isAccepted: item.IsAccepted,
            firstName: sender?.FirstName ?? "Unknown",
            lastName: sender?.LastName ?? "",
            profilePhoto: sender?.ProfilePhotoUrl,
            toProfileName: receiver
              ? `${receiver.FirstName} ${receiver.LastName}`
              : `Profile ${item.ToProfileId}`,
          };
        });

        setEventUpdates(notifications);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingNotifications(false);
    }
  }

  async function handleAccept(item) {
    try {
      console.log("item", item);

      let data = {
        RequestId: item.id,
        ProfileId: item.fromProfileId,
        ToProfileId: item.toProfileId,
        IsAccepted: 2, // Approved for the visible photos
      };
      let resp = await send_access_request(data);
      console.log("send_access_request ", resp);
      if (resp.code === 200) {
        await getEvents(client?.ProfileId, client?.BusinessDetails?.UserId); // refresh list after accept
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function handleReject(item) {
    try {
      console.log("item", item);

      let data = {
        RequestId: item.id,
        ProfileId: item.fromProfileId,
        ToProfileId: item.toProfileId,
        IsAccepted: WedlukVisibility.Rejected.id, // Reject for the visible photos
      };
      let resp = await send_access_request(data);
      console.log("send_access_request ", resp);
      if (resp.code === 200) {
        await getEvents(client?.ProfileId, client?.BusinessDetails?.UserId); // refresh list after Reject
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleNotificationClick = async (item) => {
    try {
      // you already have profile IDs
      const profileId = item.fromProfileId;

      // const resp = await get_profile_byid(profileId);

      // console.log(resp?.data[0]);

      setSelectedProfile(profileId);
    } catch (err) {
      console.log(err);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(UserData.ClientCode);
    alert("Client code copied!");
  };

  async function getProfileByID(id) {
    let resp = await get_profile_byid(id);
    console.log("client main ", resp.data[0]);
    UserData = resp?.data[0];
    setUserData(UserData);

    if (UserData.AgentId) {
      let res = await get_agent(UserData.AgentId);
      console.log(res);

      agentData = res.data;
      setAgentData(agentData);
    }
  }

  const getLanguageDescription = (langId) => {
    const language = languages.find((lang) => lang.LangId === langId);
    return language ? language.LangDesc : "Language ";
  };

  const getCitys = async (selectedState, id) => {
    let resp = await get_district_cities(selectedState, id);
    // console.log(resp.data);
    setCityList(resp.data);
  };

  const getCityName = (City) => {
    return City ? City : "City Not added";
  };

  const [casteName, setCasteName] = useState("");

  useEffect(() => {
    async function fetchCasteName() {
      const castename = await get_caste_name(UserData?.CasteLevel2Id);
      setCasteName(castename.data ? castename.data.CasteName : "Not Found");
    }

    if (UserData?.CasteLevel2Id) fetchCasteName();
  }, [UserData?.CasteLevel2Id]);

  const getReligionNameById = (id) => {
    const foundReligion = religion.find((item) => item.ReligionId === id);
    return foundReligion ? foundReligion.ReligionName : "Not Found";
  };
  const getCommunitieNameById = (id) => {
    const foundCommunitie = communityList.find(
      (item) => item.CommunitiesId === id,
    );
    return foundCommunitie ? foundCommunitie.ShortName : "";
  };
  const getMaritalStatusNameById = (id) => {
    const foundMarriageStatus = maritalStatus.find(
      (item) => item.MarriageStatusId === id,
    );
    return foundMarriageStatus ? foundMarriageStatus.MarriageStatus : "";
  };
  const getBuildNameById = (id) => {
    const foundBuildName = physicalbuildList.find(
      (item) => item.BuildId === id,
    );
    return foundBuildName ? foundBuildName.BuildName : "";
  };

  const getSkinToNameById = (id) => {
    const foundSkinTone = skinToneList.find((item) => item.SkinToneId === id);
    return foundSkinTone ? foundSkinTone.SkinToneName : "";
  };

  const loadMathesData = async (id) => {
    try {
      let resp = await get_matches_for_client(id);
      data = resp.data;
      setData(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleProfileId = async (id) => {
    await getProfileByID(id);
    if (client.ProfileId !== UserData.ProfileId) {
      await getAccesRequest(client.ProfileId, id);
      await CheckAccesRequest(id, client.ProfileId);
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth", // optional: makes it animate instead of jumping
    });
  };

  const MoveToApprovedClient = () => {
    setActiveTab("approved");
  };

  const moveToMatches = async (id) => {
    handleProfileId(id);
    setActiveTab("matches");
    setDisplayActiveTabs("Matches");
    setDisplayAprrovedProfile(true);
  };

  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (imgSrc) => {
    setSelectedImage(imgSrc);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const [editProfile, setEditProfile] = useState(false);
  const handleEditProfile = () => {
    setEditProfile(!editProfile);
  };

  const LogOut = async () => {
    await clearAllData();
    navigate("/home");
  };

  const sendAccessRequest = async () => {
    let data = {
      ProfileId: client.ProfileId,
      ToProfileId: UserData.ProfileId,
      IsAccepted: 1, //Send request
      AgentId: client?.BusinessDetails?.UserId,
    };

    let resp = await send_access_request(data);
    console.log("send_access_request ", resp);
    if (resp.code === 200) {
      handleProfileId(UserData.ProfileId);
    }
  };

  const [AccesRequestStatus, setAccesRequestStatus] = useState(null);
  const getAccesRequest = async (ProfileId, ToProfileId) => {
    console.log(ProfileId, ToProfileId);

    let resp = await get_access_request(ProfileId, ToProfileId);
    setAccesRequestStatus(resp?.data?.IsAccepted);
    console.log("getAccesRequest", resp);
  };

  const [CheckAccesRequestStatus, setCheckAccesRequestStatus] = useState(null);
  const CheckAccesRequest = async (ProfileId, ToProfileId) => {
    let resp = await check_access_request(ToProfileId, ProfileId);
    setCheckAccesRequestStatus(resp?.data);
    console.log("CheckAccesRequest", resp);
  };

  const approveTheRequest = async () => {
    let data = {
      RequestId: CheckAccesRequestStatus.RequestId,
      ProfileId: client.ProfileId,
      ToProfileId: UserData.ProfileId,
      IsAccepted: 2, // Approved for the visible photos
    };

    let resp = await send_access_request(data);
    console.log("send_access_request ", resp.data);
    if (resp.code === 200) {
      handleProfileId(UserData.ProfileId);
    }
  };

  if (!UserData)
    return (
      <div className="d-flex  align-items-center  justify-content-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    );

  return (
    <div className="main-wrapper">
      <MenuBarforClient
        client={client}
        setActiveTab={setActiveTab}
        displayActiveTab={displayActiveTab}
        setDisplayActiveTabs={setDisplayActiveTabs}
        handleProfileId={handleProfileId}
        setDisplayAprrovedProfile={setDisplayAprrovedProfile}
      />

      <div className="profile_display ">
        {displayActiveTab === "Profile" && (
          <div className="tab-container shadow-sm p-3 rounded-top-4 bg-white">
            <div className="d-flex align-items-center  gap-4">
              <div
                style={{
                  cursor: "pointer",
                  width: "25%",
                  backgroundColor: "#FFE3F0",
                }}
                className="d-flex align-items-center pe-3 border-end click-effect p-2"
                onClick={() => {
                  handleProfileId(client?.ProfileId);
                  setActiveTab("matches");
                }}
              >
                <img
                  src={
                    UserData?.User?.ProfilePhotoUrl
                      ? UserData.User.ProfilePhotoUrl
                      : "https://randomuser.me/api/portraits/women/44.jpg"
                  }
                  alt="Profile"
                  className="clinet-pro me-2"
                  width="40"
                  height="40"
                />

                <div className="d-flex flex-column">
                  <span style={{ fontSize: 14 }} className=" ">
                    {client?.User?.FirstName} {client?.User?.LastName}
                  </span>
                  <span style={{ fontSize: 10 }} className="">
                    Client Profile
                  </span>
                </div>
              </div>

              <div className="d-flex flex-wrap ms-3 gap-2">
                {tabs.map((tab) => (
                  <div className="tab-wrapper" key={tab.id}>
                    <button
                      onClick={() => setActiveTab(tab.id)}
                      className={`custom-tab ${
                        activeTab === tab.id ? "active" : ""
                      }`}
                    >
                      <img
                        src={tab.icon}
                        alt=""
                        className="tabs-icons-for-profile"
                      />
                      {tab.label}
                    </button>
                  </div>
                ))}
              </div>
            </div>
            <hr className="mt-3 mb-0" />
          </div>
        )}
        {activeTab === "matches" && (
          <div
            className={
              displayActiveTab === "Matches"
                ? "profile-container-formatches"
                : "profile-container"
            }
          >
            {/* Sidebar mathes for client */}

            {displayActiveTab === "Matches" && !displayAprrovedProfile && (
              <SidebarMatchesForClient
                data={data}
                allIcons={allIcons}
                loadMathesData={loadMathesData}
                client={client}
                MoveToApprovedClient={MoveToApprovedClient}
                handleProfileId={handleProfileId}
                setDisplayActiveTabs={setDisplayActiveTabs}
                setActiveTabforProfile={setActiveTab}
              />
            )}

            {displayActiveTab === "Matches" && (
              <div className={"main-content"}>
                <div className="d-flex justify-content-between align-items-start p-3 bg-white">
                  <div>
                    <h5 className="fw-bold mb-2" onClick={handleEditProfile}>
                      {UserData?.User?.FirstName} {UserData?.User?.LastName} ,{" "}
                      <span className="fw-normal">
                        {" "}
                        {calculateAge(UserData?.User?.DOB)} Yrs
                      </span>
                    </h5>

                    {UserData.ProfileId !== client.ProfileId &&
                      CheckAccesRequestStatus?.IsAccepted === 1 && (
                        <div
                          className="d-flex gap-4"
                          onClick={approveTheRequest}
                        >
                          <button className="accept-btn ">
                            {" "}
                            Accept Photo visbile Request ✓{" "}
                          </button>
                        </div>
                      )}
                    {/* {UserData.ProfileId !== client.ProfileId && (
                      <div className="d-flex gap-4">
                        <button className="icon-btn">
                          <img src={likeIcon} alt="" />
                        </button>
                        <button className="icon-btn">
                          <img src={allIcons.dislike_icon} alt="" />
                        </button>
                        <button className="icon-btn">
                          <img src={allIcons.copy_icon} alt="" />
                        </button>
                      </div>
                    )} */}
                  </div>
                  {/* <div class="agent-card-new">
                  <div class="agent-name">
                    {" "}
                    Agent Name : {UserData?.BusinessDetails?.BusinessName}{" "}
                  </div>
                  <div class="agent-contact">
                    Agent contact number:{" "}
                    <span class="phone-number">
                      +91 {UserData?.BusinessDetails?.AgentContactNumber}
                    </span>
                  </div>
                </div> */}
                </div>

                <div className="">
                  <div className="img-con">
                    {(UserData?.User?.WedLukDocs?.[0]?.ProfileImages || [])
                      .slice()
                      .reverse()
                      .map((img, index) => (
                        <div className="" key={index}>
                          <div className="position-relative">
                            <img
                              src={img} // Replace with your actual image path
                              alt={`Image ${index}`}
                              className={`  profile-imgages   ${
                                UserData.ProfileId !== client.ProfileId &&
                                AccesRequestStatus !== 2 &&
                                !UserData.IsPhotoVisible
                                  ? "blurred-img"
                                  : ""
                              }`}
                              onClick={() => openModal(img)}
                              style={{ cursor: "pointer" }}
                            />
                            {index === 0 &&
                              AccesRequestStatus !== 2 &&
                              UserData.ProfileId !== client.ProfileId &&
                              !UserData.IsPhotoVisible && (
                                <div
                                  className="overlay d-flex justify-content-center align-items-center"
                                  onClick={sendAccessRequest}
                                >
                                  {AccesRequestStatus !== 1 ? (
                                    <span className="btn btn-dark btn-sm">
                                      Request photo access
                                    </span>
                                  ) : (
                                    <span className="btn btn-dark btn-sm">
                                      Request Sent
                                    </span>
                                  )}
                                </div>
                              )}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                <div className="match-details-container-profile p-2">
                  {/* Left side: Matched On */}
                  <div className="matched-on-profile">
                    <div className="matched-label-profile">Matched on:</div>
                    <div className="matched-tags-profile">
                      <span>Caste</span>
                      <div className="divider" />
                      <span>Appearance</span>
                      <div className="divider" />
                      <span>Salary req</span>
                      <div className="divider" />
                      <span className="more-profile">3 more +</span>
                    </div>
                  </div>

                  {/* Right side: Network Connections */}
                  <div className="network-box-profile">
                    <div className="network-header-profile">
                      Network Connections{" "}
                      <span className="gem-icon-profile">💎</span>
                    </div>
                    <div className="network-body-profile">
                      <div className="avatars-profile">
                        <img
                          src="https://randomuser.me/api/portraits/women/65.jpg"
                          alt="Connection 1"
                        />
                        <img
                          src="https://randomuser.me/api/portraits/men/45.jpg"
                          alt="Connection 2"
                        />
                      </div>
                      <span className="connection-text-profile">
                        5+ connections identified
                      </span>
                    </div>
                  </div>
                </div>

                <div className="row g-4 fs-6 p-1">
                  {/* Background Section */}
                  <div className="col-md-6">
                    <div className="p-3 bg-white rounded shadow-sm border">
                      <h6 className="text-color mb-3">Background</h6>

                      <div className="row">
                        {/* Left Column */}
                        <div className="col-6">
                          <div className="d-flex align-items-center mb-4">
                            <img
                              src={CasteIcon}
                              alt=""
                              className="icons-for-bg"
                            />
                            <div>
                              <strong className="title-for-bg">
                                {getReligionNameById(UserData?.ReligionId)}
                              </strong>
                              <br />
                              <small>{casteName}</small>
                            </div>
                          </div>

                          <div className="d-flex align-items-center mb-4">
                            <img
                              src={LangIcon}
                              alt=""
                              className="icons-for-bg"
                            />
                            <div>
                              {languages
                                .filter((item) =>
                                  UserData?.User?.UserLanguage.includes(
                                    item.LangId,
                                  ),
                                )
                                .map((language) => (
                                  <strong
                                    className="title-for-bg"
                                    key={language.LangId}
                                  >
                                    {language.LangDesc},{" "}
                                  </strong>
                                ))}
                            </div>
                          </div>
                        </div>

                        {/* Right Column */}
                        <div className="col-6">
                          <div className="d-flex align-items-center mb-4">
                            <img
                              src={FromLocationIcon}
                              alt=""
                              className="icons-for-bg"
                            />
                            <div>
                              <div>
                                <strong className="title-for-bg">
                                  {getCityName(UserData?.User?.Address?.CityId)}
                                </strong>
                              </div>
                            </div>
                          </div>

                          <div className="d-flex align-items-center">
                            <img
                              src={MarryIcon}
                              alt=""
                              className="icons-for-bg"
                            />
                            <div>
                              <strong className="title-for-bg">
                                {getMaritalStatusNameById(
                                  UserData?.MarriageStatusId,
                                )}
                              </strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Physique Section */}
                  <div className="col-md-6">
                    <div className="p-3 bg-white rounded shadow-sm border mb-4">
                      <div className=" ">
                        <h6 className="text-color mb-3">Physique</h6>
                        <div className="row-line">
                          <div className="vertical-divider" />
                          <div className="value-text">
                            {UserData?.Height} feet
                          </div>
                          <div className="vertical-divider" />
                          <div className="value-text">
                            {UserData?.Weight} Kg
                          </div>
                        </div>
                        <div className="row-line bottom-row">
                          <div className="label-group">
                            <div className="label-text">Build</div>
                            <div className="bold-text-for-value">
                              {" "}
                              {getBuildNameById(UserData?.BuildId)}
                            </div>
                          </div>
                          <div className="label-group">
                            <div className="label-text">Skin tone</div>
                            <div className="bold-text-for-value">
                              {" "}
                              {getSkinToNameById(UserData?.SkinToneId)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <FamilyDetails
                    familyMembers={UserData?.User.familyDetails}
                    relationList={relationList}
                    familyWealth={UserData?.User.familyWealth}
                  />

                  {UserData && (
                    <EducationAndCareer
                      UserData={UserData}
                      selectedQualification={selectedQualification}
                      qualifications={qualifications}
                    />
                  )}

                  {UserData && (
                    <IntroductionVideo
                      habitList={habitList}
                      hobbiesList={hobbiesList}
                      MainProfile={client}
                      UserData={UserData}
                      AccesRequestStatus={true}
                    />
                  )}
                </div>
              </div>
            )}

            {displayActiveTab === "Profile" && (
              <div className="d-flex">
                <div className="profile-container-profile">
                  <div className="d-flex justify-content-between align-items-start p-3 bg-white">
                    <div>
                      <h5 className="fw-bold mb-2" onClick={handleEditProfile}>
                        {UserData?.User?.FirstName} {UserData?.User?.LastName} ,{" "}
                        <span className="fw-normal">
                          {" "}
                          {calculateAge(UserData?.User?.DOB)} Yrs
                        </span>
                      </h5>
                      {UserData.ProfileId !== client.ProfileId && (
                        <div className="d-flex gap-4">
                          <button className="icon-btn">
                            <img src={likeIcon} alt="" />
                          </button>
                          <button className="icon-btn">
                            <img src={allIcons.dislike_icon} alt="" />
                          </button>
                          <button className="icon-btn">
                            <img src={allIcons.copy_icon} alt="" />
                          </button>
                          <button className="icon-btn">
                            <img src={allIcons.share_icon} alt="" />
                          </button>
                        </div>
                      )}
                    </div>

                    {/* <div class="agent-card-new">
                  <div class="agent-name">
                    {" "}
                    Agent Name : {UserData?.BusinessDetails?.BusinessName}{" "}
                  </div>
                  <div class="agent-contact">
                    Agent contact number:{" "}
                    <span class="phone-number">
                      +91 {UserData?.BusinessDetails?.AgentContactNumber}
                    </span>
                  </div>
                </div> */}
                  </div>

                  <div className="client-panel mx-2 my-1">
                    <div className="left-clinet-panel">
                      <div className="icon-circle">
                        <img
                          src={require("../assests/images/settings-client.png")}
                          alt="Settings"
                        />
                      </div>
                      <div
                        className="icon-circle"
                        onClick={() =>
                          navigate("/EditClientProfile", {
                            state: { client: UserData },
                          })
                        }
                      >
                        <img
                          src={require("../assests/images/notes-icon.png")}
                          alt="Edit"
                        />
                      </div>
                    </div>

                    <div className="client-code">
                      <span>Client code: </span>
                      <span className="code"># {UserData.ClientCode}</span>
                      <img
                        src={require("../assests/images/copy-icon.png")}
                        alt="Copy"
                        className="copy-icon"
                        onClick={handleCopy}
                      />
                    </div>
                  </div>

                  <div className="">
                    <div className="img-con">
                      {(UserData?.User?.WedLukDocs?.[0]?.ProfileImages || [])
                        .slice()
                        .reverse()
                        .map((img, index) => (
                          <div className="" key={index}>
                            <div className="position-relative">
                              <img
                                src={img} // Replace with your actual image path
                                alt={`Image ${index}`}
                                className="profile-imgages "
                                onClick={() => openModal(img)}
                                style={{ cursor: "pointer" }}
                              />
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>

                  <div className="row g-4 fs-6 p-1 mt-2">
                    {/* Background Section */}
                    <div className="col-md-6">
                      <div className="p-3 bg-white rounded shadow-sm border">
                        <h6 className="text-color mb-3">Background</h6>

                        <div className="row">
                          {/* Left Column */}
                          <div className="col-6">
                            <div className="d-flex align-items-center mb-4">
                              <img
                                src={CasteIcon}
                                alt=""
                                className="icons-for-bg"
                              />
                              <div>
                                <strong className="title-for-bg">
                                  {getReligionNameById(UserData?.ReligionId)}
                                </strong>
                                <br />
                                <small>{casteName}</small>
                              </div>
                            </div>

                            <div className="d-flex align-items-center mb-4">
                              <img
                                src={LangIcon}
                                alt=""
                                className="icons-for-bg"
                              />
                              <div>
                                {languages
                                  .filter((item) =>
                                    UserData?.User?.UserLanguage.includes(
                                      item.LangId,
                                    ),
                                  )
                                  .map((language) => (
                                    <strong
                                      className="title-for-bg"
                                      key={language.LangId}
                                    >
                                      {language.LangDesc},{" "}
                                    </strong>
                                  ))}
                              </div>
                            </div>
                          </div>

                          {/* Right Column */}
                          <div className="col-6">
                            <div className="d-flex align-items-center mb-4">
                              <img
                                src={FromLocationIcon}
                                alt=""
                                className="icons-for-bg"
                              />
                              <div>
                                <div>
                                  <strong className="title-for-bg">
                                    {getCityName(
                                      UserData?.User?.Address?.CityId,
                                    )}
                                  </strong>
                                </div>
                              </div>
                            </div>

                            <div className="d-flex align-items-center">
                              <img
                                src={MarryIcon}
                                alt=""
                                className="icons-for-bg"
                              />
                              <div>
                                <strong className="title-for-bg">
                                  {getMaritalStatusNameById(
                                    UserData?.MarriageStatusId,
                                  )}
                                </strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Physique Section */}
                    <div className="col-md-6">
                      <div className="p-3 bg-white rounded shadow-sm border mb-4">
                        <div className=" ">
                          <h6 className="text-color mb-3">Physique</h6>
                          <div className="row-line">
                            <div className="vertical-divider" />
                            <div className="value-text">
                              {UserData?.Height} feet
                            </div>
                            <div className="vertical-divider" />
                            <div className="value-text">
                              {UserData?.Weight} Kg
                            </div>
                          </div>
                          <div className="row-line bottom-row">
                            <div className="label-group">
                              <div className="label-text">Build</div>
                              <div className="bold-text-for-value">
                                {" "}
                                {getBuildNameById(UserData?.BuildId)}
                              </div>
                            </div>
                            <div className="label-group">
                              <div className="label-text">Skin tone</div>
                              <div className="bold-text-for-value">
                                {" "}
                                {getSkinToNameById(UserData?.SkinToneId)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <FamilyDetails
                      familyMembers={UserData?.User.familyDetails}
                      relationList={relationList}
                    />

                    {UserData && (
                      <EducationAndCareer
                        UserData={UserData}
                        selectedQualification={selectedQualification}
                        qualifications={qualifications}
                      />
                    )}

                    {UserData && (
                      <IntroductionVideo
                        habitList={habitList}
                        hobbiesList={hobbiesList}
                        MainProfile={client}
                        UserData={UserData}
                        AccesRequestStatus={true}
                      />
                    )}
                  </div>
                </div>
                {selectedProfile && (
                  <div
                    className="profile-overlay"
                    onClick={() => setSelectedProfile(null)}
                  >
                    <div
                      className="profile-modal"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <DashboardProfileView
                        profileId={selectedProfile}
                        onClose={() => setSelectedProfile(null)}
                      />
                    </div>
                  </div>
                )}
                <div className="notification-panel">
                  <div style={{ position: "relative", overflow: "hidden" }}>
                    <div className="notification-header-bg" />
                    <div className="notification-header-content">
                      <h5 className="notification-title">Notifications</h5>
                      <div className="notification-underline" />
                    </div>
                  </div>

                  {loadingNotifications ? (
                    [...Array(5)].map((_, index) => (
                      <div
                        key={index}
                        className="notification-item shadow-sm p-2 mb-2 rounded"
                      >
                        <div className="d-flex align-items-center">
                          <div className="skeleton-avatar"></div>

                          <div className="ms-2 flex-grow-1">
                            <div className="skeleton-line w-50 mb-2"></div>
                            <div className="skeleton-line w-75"></div>
                          </div>
                        </div>

                        <div className="d-flex justify-content-around mt-3">
                          <div className="skeleton-btn"></div>
                          <div className="skeleton-btn"></div>
                        </div>
                      </div>
                    ))
                  ) : eventUpdates.length === 0 ? (
                    <div className="text-muted p-3">No notifications</div>
                  ) : (
                    [...eventUpdates].reverse().map((item) => (
                      <div
                        key={item.id}
                        className="notification-item shadow-sm p-2 mb-2 rounded"
                      >
                        <div
                          className="d-flex align-items-center justify-content-between"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleNotificationClick(item)}
                        >
                          <div className="d-flex align-items-center">
                            {item.profilePhoto ? (
                              <img
                                src={item.profilePhoto}
                                alt="profile"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  marginRight: "10px",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <img
                                src={require("../assests/images/profile.png")}
                                alt="profile"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  marginRight: "10px",
                                }}
                              />
                            )}

                            <div>
                              <div className="fw-semibold">
                                {item.firstName} {item.lastName}
                              </div>
                              <div className="text-muted small">
                                {item.isAccepted === 2
                                  ? `Profile request accepted `
                                  : item.isAccepted === 3
                                    ? `Profile request rejected  `
                                    : `Sent request to profile  `}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex justify-content-around mx-2 my-2">
                          {item.isAccepted == 1 && (
                            <button
                              className="btn btn-sm btn-success"
                              onClick={() => handleAccept(item)}
                            >
                              Accept
                            </button>
                          )}
                          {item.isAccepted == 1 && (
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleReject(item)}
                            >
                              Reject
                            </button>
                          )}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === "preferences" && (
          <div className="profile-container">
            <ClientPreferences UserData={UserData} />
          </div>
        )}
        {activeTab === "approved" && (
          <div className="profile-container">
            <ApprovedProfilesForClient
              profiles={data}
              moveToMatches={moveToMatches}
            />
          </div>
        )}
        {activeTab === "network" && (
          <div className="profile-container  d-flex justify-content-center pt-4">
            <div className="title">Coming Soon</div>
          </div>
        )}

        {displayActiveTab === "Profile" && (
          <button
            className="finish-button mt-4 mb-4 click-effect"
            onClick={LogOut}
          >
            Log Out
          </button>
        )}

        {selectedImage && (
          <div className="image-modal" onClick={closeModal}>
            <div
              className="image-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <img src={selectedImage} alt="Full view" />
              <button className="close-btn" onClick={closeModal}>
                ×
              </button>
            </div>
          </div>
        )}
        {displayActiveTab === "My Agent" && (
          <div>
            {" "}
            <MyAgent
              agentData={agentData}
              languages={languages}
              UserData={UserData}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileDisplayForClient;
